import React from 'react'
import 'swiper/css';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules'; 
import './Partners.css'

const PARTNERS = [
  {
    name: "Freedom Transportation",
    className: "partners_swiper_slide1",
    href: "https://freedomtrans.com/",
  },
  {
    name: "Amazon",
    className: "partners_swiper_slide2",
    href: "https://www.amazon.com/",
  },
  {
    name: "ITS",
    className: "partners_swiper_slide3",
    href: "https://www.its4logistics.com/",
  },
  {
    name: "J.B Hunt",
    className: "partners_swiper_slide4",
    href: "https://www.jbhunt.com/",
  },
  {
    name: "Coyote",
    className: "partners_swiper_slide5",
    href: "https://coyote.com/",
  },
  {
    name: "Veltiri",
    className: "partners_swiper_slide6",
    href: "https://veltri.com/",
  },
  {
    name: "Forward Air",
    className: "partners_swiper_slide7",
    href: "https://www.forwardair.com/",
  },
];

function Partners() {
  return (
    <div className='partners'>
        <h2>Partners We Work With</h2>
         <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        loop={true}
        speed={1000} 
        autoplay={{
          delay: 2500, 
          disableOnInteraction: false,
        }}
        breakpoints={{
            320: { slidesPerView: 1 },
            375: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            960: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
        }}
        allowTouchMove={true} 
        className="partners_swiper"
      >
            {PARTNERS.map(({ name, className, href }) => (
                <SwiperSlide className={className} key={name}>
                <div className="overlay_bg"></div>
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {name}
                </a>
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
  )
}

export default Partners

